import { useStore } from "vuex";
import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";

export default function useLogin() {
  const router = useRouter();
  const store = useStore();

  const email = ref("");
  const password = ref("");
  const checkbox = ref(!!store.getters["auth/getRememberMe"]);
  const errors = computed(() => store.getters["auth/getLoginErrors"]);
  const isLoggedIn = computed(() => store.getters["auth/isLoggedIn"]);

  watch(isLoggedIn, (newValue, oldValue) => {
    console.log("debug", newValue, oldValue);
    if (newValue) {
      router.push({ name: "courses" });
      setTimeout(() => {
        location.reload();
      }, 500);
    }
  });

  const handleSubmit = async () => {
    const data = {
      email: email.value,
      password: password.value,
    };
    await store.dispatch("auth/login", data);
    if (checkbox.value) {
      store.commit("auth/SET_REMEMBER_ME");
    } else {
      store.commit("auth/CLEAR_REMEMBER_ME");
    }
  };

  return {
    email,
    password,
    checkbox,
    errors,
    handleSubmit,
  };
}
